import { Link } from "react-router-dom";
import icCalendar from "@/assets/icons/ic-calendar.svg";
import { ChevronRight } from "lucide-react";
import { formatDate } from "@/lib/utils";
import DOMPurify from "dompurify";
import { TruncatedTooltip } from "../ui/truncated-tooltip";
import { SafeImage } from "../ui/safe-image/safe-image";
import IcRight from "@/assets/icons/ic-arr-right.svg";

export interface CardNewsData {
  id: string;
  image: string;
  title: string;
  description: string;
  date: string;
  href?: string;
}

export const CardNews = ({ data }: { data: CardNewsData }) => {
  const { image, title, description, date, href = "#" } = data;
  return (
    <div className="flex flex-col w-full bg-bg-surface border border-border-neutral-light rounded-[4px] overflow-hidden hover:shadow-bottom-100 transition-shadow lg:max-h-[408px] max-h-[400px]">
      <div className="relative w-full h-[192px] shrink-0 overflow-hidden">
        <SafeImage src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      </div>

      <div className="flex flex-col gap-[24px] p-4 lg:px-6 lg:py-5">
        <div className="flex flex-col gap-1">
          <TruncatedTooltip className="text-h3 font-medium text-black  line-clamp-2 leading-6 lg:leading-7 tracking-[-0.4px] min-h-[56px]">
            {title}
          </TruncatedTooltip>
          <p
            className="text-body text-black line-clamp-3 leading-6 tracking-[-0.16px] min-h-[72px] break-works"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description),
            }}
          ></p> 
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 h-5 px-1 py-0.5  rounded-2xs bg-[#EBEBEB]">
            <img src={icCalendar} alt="" width={16} height={16} className="shrink-0" />
            <span className="text-caption text-black font-medium whitespace-nowrap ">
              {formatDate(date, "YYYY-MM-DD")}
            </span>
          </div>

          <Link
            to={href}
            className="flex items-center gap-1 h-4 text-black  transition-opacity"
            aria-label={`${title} 자세히 보기`}
          >
            <span className="text-caption font-bold text-black">더 보기</span>
            <img src={IcRight} alt="" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardNews;
